/* eslint-disable no-restricted-globals */
/* eslint-disable consistent-return */
import React, { useState, useRef, useEffect, forwardRef } from 'react';
import { Picker } from 'emoji-mart';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import ReactTooltip from 'react-tooltip';
/* import { getEnvironment } from '../../../api/utils'; */
import bp from '../../../config/breakpoints';
import { KEYS } from '../../../config/keys';
import { addMessageToDB } from '../../../db/dbUtils';
import { withI18n } from '../../../hocs';
import useMessageRetry from '../../../hooks/useMessageRetry';
import { MSG_CONTENT_TYPES, MODAL_TYPE, MSG_SEND_TYPE } from '../../../models';
import { ContactsService, ChatGenService } from '../../../services';
import SessionStorageService from '../../../services/session-storage-service';
import { useSocketContext } from '../../../sockets/context';
import { sendMessage } from '../../../sockets/emit';
import {
  ImageFilledIcon,
  CameraFilledIcon,
  VolumeUpFilledIcon,
  DocumentFilledIcon,
  SendIcon,
  AttachIcon,
  IconButton,
  AddIcon,
  DeleteIcon,
  EmojiIcon,
  PapersIcon,
  VerticalDotsIcon,
  AiIcon,
  WarningMessage,
} from '../../atoms';
import FloatingMenu from '../FloatingMenu';
import {
  SendInputStyled,
  DropdownMenu,
  MenuItem,
  StyledTextArea,
  Wrapper,
  Overlay,
  Blocker,
} from './styled';
import useWhenComponentBlur from './useWhenComponentBlur';

// create pop up for attaching
const AttachMenuSelector = ({ i18n, onAttachEvent, onSelectMenu }) => {
  return (
    <div className="selector ts ts-ease-out">
      <ul className="ts ts-ease-out">
        <li className="ts ts-ease-out">
          <IconButton
            className="menu-button"
            onClick={() => {
              onSelectMenu();
              onAttachEvent(MODAL_TYPE.ATTACH.IMAGE);
            }}
          >
            <ImageFilledIcon className="menu-button-icon ts" />
            {i18n.attachMenu.image}
          </IconButton>
        </li>
        <li className="ts ts-ease-out">
          <IconButton
            className="menu-button"
            onClick={() => {
              onSelectMenu();
              onAttachEvent(MODAL_TYPE.ATTACH.VIDEO);
            }}
          >
            <CameraFilledIcon className="menu-button-icon ts" />
            {i18n.attachMenu.video}
          </IconButton>
        </li>
        <li className="ts ts-ease-out">
          <IconButton
            className="menu-button"
            onClick={() => {
              onSelectMenu();
              onAttachEvent(MODAL_TYPE.ATTACH.DOCUMENT);
            }}
          >
            <DocumentFilledIcon className="menu-button-icon ts" />
            {i18n.attachMenu.document}
          </IconButton>
        </li>
        <li className="ts ts-ease-out">
          <IconButton
            className="menu-button"
            onClick={() => {
              onSelectMenu();
              onAttachEvent(MODAL_TYPE.ATTACH.AUDIO);
            }}
          >
            <VolumeUpFilledIcon className="menu-button-icon ts" />
            {i18n.attachMenu.audio}
          </IconButton>
        </li>
      </ul>
    </div>
  );
};

AttachMenuSelector.propTypes = {
  i18n: PropTypes.object,
  onAttachEvent: PropTypes.func,
  onSelectMenu: PropTypes.func,
};

const TemplateSelector = forwardRef(
  (
    {
      disabledTemplateSending,
      i18n,
      list,
      title,
      onTemplateSelected,
      onAddTemplate,
      onDeleteTemplate,
      hideToolTip,
      isAuditor,
      sendTemplate,
      setTemplateToPreview,
    },
    ref
  ) => {
    const deleteTemplate = (e, fragmentId) => {
      e.preventDefault();
      e.stopPropagation();
      onDeleteTemplate(fragmentId);
    };

    const [selectedOption, setSelectedOption] = useState('all');
    let filteredList = list;
    if (list) {
      if (!isAuditor) {
        filteredList = list.filter((el) => el && !el.onlyAuditor);
      } else if (selectedOption === 'onlyAuditor') {
        filteredList = list.filter((el) => el && el.onlyAuditor) || [];
      }
    }

    const handleRadioChange = (event) => {
      setSelectedOption(event.target.value);
    };
    const [actionsMenu, setActionsMenu] = useState({
      isOpen: false,
      top: 0,
      left: 0,
    });

    const handleToggleOptions = (event, templateId) => {
      event.stopPropagation();
      const { top, left, height } = event.currentTarget.getBoundingClientRect();
      setActionsMenu((prevMenu) => ({
        isOpen: prevMenu.isOpen === templateId ? false : templateId, // Open menu only for the clicked template
        top: top + height,
        left,
      }));
    };

    const handleClickOutside = (event) => {
      if (!event.target.closest('.fragment-element')) {
        setActionsMenu((prevMenu) => ({
          ...prevMenu,
          isOpen: false,
        }));
      }
    };

    useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [actionsMenu]);
    return (
      <section ref={ref} className="fragment-selector">
        <header className="fragment-selector-header">
          <span className="fragment-selector-title">{title}</span>
          <IconButton
            className="add-fragment-button"
            onClick={onAddTemplate}
            toolTip={i18n.templateSelector.addTemplate}
            toolTipPosition="top"
            toolTipPositionOffset={5}
          >
            <AddIcon />
          </IconButton>
        </header>
        {isAuditor ? (
          <div>
            <form className="form-radios">
              <p className="radio-title">{i18n.templateSelector.titleRadios}</p>
              <div className="flex-form-radio">
                <div className="radio-content">
                  <label className="label-radio" htmlFor="onlyAuditor">
                    {i18n.templateSelector.auditor}
                  </label>
                  <input
                    checked={selectedOption === 'onlyAuditor'}
                    className="input-radio"
                    id="onlyAuditor"
                    name="fav_language"
                    onChange={handleRadioChange}
                    type="radio"
                    value="onlyAuditor"
                  />
                </div>
                <div className="radio-content">
                  <label className="label-radio" htmlFor="all">
                    {i18n.templateSelector.all}
                  </label>
                  <input
                    checked={selectedOption === 'all'}
                    className="input-radio"
                    id="all"
                    name="fav_language"
                    onChange={handleRadioChange}
                    type="radio"
                    value="all"
                  />
                </div>
              </div>
              <hr />
            </form>
          </div>
        ) : (
          <div />
        )}
        <ul className="ts ts-ease-out">
          {filteredList &&
            filteredList.map((template) => {
              const isTemplate =
                template?.template?.contentType?.toLowerCase() === 'template';
              return (
                <li
                  key={`template-${template.id}`}
                  className="ts ts-ease-out fragment-element"
                  onClick={
                    template && template.onlyAuditor
                      ? () => {}
                      : () => onTemplateSelected(template.message)
                  }
                >
                  <p className="fragment-element-title">{template.title}</p>
                  <p className="fragment-element-message">{template.message}</p>
                  {isAuditor &&
                    template &&
                    template.onlyAuditor &&
                    template.template && (
                      <IconButton
                        className="delete-button"
                        disabled={disabledTemplateSending}
                        disableToolTip={hideToolTip}
                        onClick={
                          disabledTemplateSending
                            ? null
                            : () => sendTemplate(template.template)
                        }
                        toolTip={i18n.templateSelector.sendTemplate}
                        toolTipPosition="top"
                        toolTipPositionOffset={5}
                      >
                        <SendIcon className="send-icon ts" />
                      </IconButton>
                    )}
                  {!isTemplate && (
                    <IconButton
                      className="delete-button"
                      disableToolTip={hideToolTip}
                      onClick={(e) => deleteTemplate(e, template.id)}
                      toolTip={i18n.templateSelector.deleteTemplate}
                      toolTipPosition="top"
                      toolTipPositionOffset={5}
                    >
                      <DeleteIcon className="send-icon ts" />
                    </IconButton>
                  )}
                  {isTemplate && (
                    <>
                      <IconButton
                        className="delete-button"
                        disableToolTip={hideToolTip}
                        onClick={(e) => handleToggleOptions(e, template.id)} // Pass template id to differentiate
                        toolTip={i18n.templateSelector.moreActions}
                        toolTipPosition="top"
                        toolTipPositionOffset={5}
                      >
                        <VerticalDotsIcon className="send-icon ts" />
                      </IconButton>
                      <DropdownMenu
                        isOpen={actionsMenu.isOpen === template.id} // Check if this menu should be open
                        left={actionsMenu.left}
                        onClick={(e) => e.stopPropagation()}
                        top={actionsMenu.top}
                      >
                        <MenuItem
                          onClick={(e) => deleteTemplate(e, template.id)}
                        >
                          {i18n.templateSelector.deleteTemplate}
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setTemplateToPreview(template);
                          }}
                        >
                          {i18n.templateSelector.viewTemplate}
                        </MenuItem>
                      </DropdownMenu>
                    </>
                  )}
                </li>
              );
            })}
        </ul>
      </section>
    );
  }
);

TemplateSelector.propTypes = {
  disabledTemplateSending: PropTypes.bool,
  hideToolTip: PropTypes.bool,
  i18n: PropTypes.object,
  isAuditor: PropTypes.bool,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      message: PropTypes.string,
    })
  ),
  onAddTemplate: PropTypes.func.isRequired,
  onDeleteTemplate: PropTypes.func.isRequired,
  onTemplateSelected: PropTypes.func.isRequired,
  sendTemplate: PropTypes.func,
  setTemplateToPreview: PropTypes.func,
  title: PropTypes.string,
};

const SendMessageInput = ({
  i18n,
  templateList,
  onAttachEvent,
  onAddTemplate,
  onDeleteTemplate,
  assignConvToMyself,
  sendTemplate,
  showOnlyButton,
  isAuditor,
  setGlobalState,
  conversations,
  setScrollAllowed,
  disabledTemplateSending,
  setTemplateToPreview,
  disconnected,
  setRetryTimers,
  isLocked,
}) => {
  const [disconnectedForAWhile, setDisconnectedForAWhile] = useState(false);
  const timeoutRef = useRef();

  /* this useEffect's functionality is to be able to do a timeout since we receive a disconnected event to filter out when
   * the sockets refreshes */
  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    if (disconnected) {
      timeoutRef.current = setTimeout(() => {
        setDisconnectedForAWhile(true);
      }, 7000);
    } else {
      setDisconnectedForAWhile(false);
    }
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [disconnected]);

  const isMediumScreen = useMediaQuery({ query: `(max-width: ${bp.md}px)` });
  const inputRef = useRef(null);
  const divRef = useRef(null);
  const emojiPickerRef = useRef(null);
  const templateSelectorRef = useRef(null);
  /* const [environment, setEnvironment] = useState(null); */
  const [summaryAi, setSummaryAi] = useState(null);
  const [suggestionAi, setSuggestionAi] = useState(null);
  const [sourcesAi, setSourcesAi] = useState(null);
  const [isAiLoading, setIsAiLoading] = useState(false);
  const [caret, setCaret] = useState(null);
  const [showAttachMenu, setShowAttachMenu] = useState(false);
  const [showAiMenu, setShowAiMenu] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [showTemplateSelector, setShowTemplateSelector] = useState(false);
  const { selectedChatId, isMessageSent, setIsMessageSent } =
    useSocketContext();

  const [value, setValue] = useState('');

  const prevChatIdRef = useRef(selectedChatId);

  // On mount, load the initial chat’s text
  useEffect(() => {
    setValue(SessionStorageService.getTextForChat(selectedChatId));
  }, []);

  // Whenever selectedChatId or value changes, save the old chat’s text and load the new one
  useEffect(() => {
    const prevId = prevChatIdRef.current;
    if (prevId !== selectedChatId) {
      SessionStorageService.setTextForChat(prevId, value);
      setValue(SessionStorageService.getTextForChat(selectedChatId));
      prevChatIdRef.current = selectedChatId;
    }
  }, [selectedChatId, value]);

  useMessageRetry(sendMessage, setRetryTimers);

  const [anchorIaMenu, setAnchorIaMenu] = useState(null);
  useEffect(() => {
    function hideError(e) {
      if (
        e.message ===
        'ResizeObserver loop completed with undelivered notifications.'
      ) {
        const resizeObserverErrDiv = document.getElementById(
          'webpack-dev-server-client-overlay-div'
        );
        const resizeObserverErr = document.getElementById(
          'webpack-dev-server-client-overlay'
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute('style', 'display: none');
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute('style', 'display: none');
        }
      }
    }

    window.addEventListener('error', hideError);
    return () => {
      window.addEventListener('error', hideError);
    };
  }, []);

  /* useEffect(() => {
    setEnvironment(getEnvironment());
  }, []); */

  useWhenComponentBlur(() => {
    setShowEmojiPicker(false);
  }, emojiPickerRef);

  useWhenComponentBlur(() => {
    setShowTemplateSelector(false);
  }, templateSelectorRef);

  useEffect(() => {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  }, [value, isMessageSent]);

  const closeAttachMenu = () => {
    if (showAttachMenu) {
      setShowAttachMenu(false);
    }
  };
  const setSuggestionAsValue = (suggestion) => {
    setValue(suggestion || '');
  };
  const handleKeyUp = (e) => {
    switch (e.key) {
      case 'Escape':
        closeAttachMenu();
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    window.addEventListener('keyup', handleKeyUp);
    return () => window.removeEventListener('keyup', handleKeyUp);
  });

  /* useEffect(() => {
      const autosize = () => {
        if (inputRef.current) {
          const style = window.getComputedStyle(inputRef.current);
          let lineHeight = parseInt(style.lineHeight, 10);

          if (Number.isNaN(lineHeight)) {
            lineHeight = 20;
          }

          inputRef.current.style.height = '40px';

          const scrollHeight = inputRef?.current?.scrollHeight;
          const maxHeight = lineHeight * 3;

          inputRef.current.style.height = `${Math.max(40, Math.min(scrollHeight, maxHeight))}px`;
        }
      };

      if (inputRef.current) {
        autosize();
        inputRef.current.addEventListener('input', autosize);
      }

      return () => {
        if (inputRef.current) {
          inputRef.current.removeEventListener('input', autosize);
        }
      };
    }, [value]); */

  useEffect(() => {
    window.addEventListener('click', () => {
      closeAttachMenu();
    });
    return () =>
      window.removeEventListener('click', () => {
        closeAttachMenu();
      });
  });

  const onChangeHandler = (e) => {
    e.preventDefault();
    setValue(e.target.value);
  };
  const generateGuid = () => {
    if (self && self.crypto) {
      return self.crypto.randomUUID();
    }
    return null;
  };
  const sendMessageHandler = async () => {
    const regExpressionWhiteSpaces = /^\s*$/;
    const isWhiteSpaces = regExpressionWhiteSpaces.test(value);
    const guid = generateGuid();
    if (value !== '' && !isWhiteSpaces) {
      const message = {
        conversationSessionId: selectedChatId,
        content: {
          body: value.trim(),
        },
        agentMessageId: guid,
        sendType: MSG_SEND_TYPE.OPERATOR,
        status: 'queued',
        contentType: MSG_CONTENT_TYPES.TEXT,
      };

      setGlobalState((state) => {
        const aux = [...conversations];
        if (aux.length > 0) {
          const index = _.findIndex(
            aux,
            (conv) => conv.conversationSessionId === selectedChatId
          );
          const newTimespan = new Date();
          if (message.status === 'queued' || !message.status) {
            setScrollAllowed({
              isAllowed: true,
              options: { behavior: 'smooth' },
            });
            message.timespan = newTimespan;
            aux[index].messages.push(message);
          }
          return { ...state, conversations: aux };
        }
      });
      await addMessageToDB({ ...message, retries: 0, timestamp: Date.now() });
      sendMessage(message);
      setIsMessageSent(false);
      setValue('');

      /* // Set textarea height 40px
      if (inputRef.current) {
        setTimeout(() => {
          inputRef.current.style.height = '40px';
        }, 0);
      } */
    }
  };

  if (isMessageSent) {
    setIsMessageSent(false);
  }

  const introSubmit = (e) => {
    if (e.shiftKey && e.which === KEYS.INTRO) {
      e.preventDefault();
      const position = inputRef.current.selectionStart;
      const newValue = `${value.substring(0, position)}\n${value.substring(position)}`;
      setValue(newValue);
      inputRef.current.selectionStart = position + 1;
      inputRef.current.selectionEnd = position + 1;
    } else if (e.which === KEYS.INTRO) {
      e.preventDefault();
      sendMessageHandler();
    }
  };
  const updateAiInfo = (summary, suggestion, sources) => {
    setSummaryAi(summary);
    setSuggestionAi(suggestion);
    setSourcesAi(sources);
    setIsAiLoading(false);
  };

  const loadInfoAi = async () => {
    setIsAiLoading(true);
    let summary = null;
    let suggestion = null;
    let sources = null;

    try {
      // Obtener integración de la IA
      const integration = await ChatGenService.getIntegrationIagen();
      const agentId = integration?.config?.iaGenDefaultHelperBot;

      const selectedConv = conversations.find(
        (el) => el.conversationSessionId === selectedChatId
      );

      const lastMessage =
        selectedConv?.messages?.length &&
        selectedConv.messages[selectedConv.messages.length - 1];

      summary = await ContactsService.getSummaryHistory(selectedChatId);

      // Only request suggestions and sources if agentId is available
      if (agentId) {
        const response = await ChatGenService.askForSuggestion(
          selectedChatId,
          lastMessage?.messageId,
          summary,
          agentId
        );
        suggestion = response?.suggestion || null;
        sources = response?.sources || null;
      }
    } catch (error) {
      console.error('Error getting suggestions:', error);
    } finally {
      setIsAiLoading(false);
    }

    // Actualizar información de la IA
    updateAiInfo(summary, suggestion, sources);
  };

  const onAiIconClicked = async (e) => {
    setAnchorIaMenu(e.currentTarget);
    e.stopPropagation();
    e.preventDefault();
    setShowAiMenu(!showAiMenu);
    await loadInfoAi();
  };

  const onAttachClicked = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setShowAttachMenu(!showAttachMenu);
    setShowTemplateSelector(false);
  };

  const handleTemplatesClicked = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setShowAttachMenu(false);
    setShowTemplateSelector(true);
  };

  const addEmoji = (emoji) => {
    const { start, end } = caret || {};
    setValue((val) => val.substring(0, start) + emoji + val.substring(end));
    setShowEmojiPicker(false);
  };

  const handleAddTemplate = () => {
    setShowTemplateSelector(false);
    onAddTemplate();
  };

  return (
    <Wrapper>
      <SendInputStyled
        disabled={isMessageSent || isLocked}
        showAttachMenu={showAttachMenu}
        showOnlyButton={showOnlyButton}
        showTemplateSelector={showTemplateSelector}
      >
        {!showOnlyButton ? (
          <>
            <IconButton
              className="attach-button"
              disabled={isMessageSent || isLocked}
              disableToolTip={isMediumScreen}
              onClick={onAttachClicked}
              toolTip={i18n.attachMenu.attachButtonTooltip}
              toolTipPosition="top"
              toolTipPositionOffset={5}
            >
              <AttachIcon className="attach-icon ts" />
            </IconButton>
            <IconButton
              className="fragments-button"
              disabled={isMessageSent || isLocked}
              disableToolTip={isMediumScreen}
              onClick={handleTemplatesClicked}
              toolTip={i18n.templateSelector.tooltip}
              toolTipPosition="top"
              toolTipPositionOffset={5}
            >
              <PapersIcon className="fragments-icon ts" />
            </IconButton>
            {showEmojiPicker && (
              <div ref={emojiPickerRef} className="emoji-picker">
                <Picker
                  i18n={i18n.emojiPicker}
                  onSelect={(emoji) => addEmoji(emoji.native)}
                  set="facebook"
                  title={i18n.emojiPicker.title}
                />
              </div>
            )}
            <IconButton
              className="emoji-button"
              disabled={isMessageSent || isLocked}
              onClick={() => setShowEmojiPicker((showing) => !showing)}
            >
              <EmojiIcon className="emoji-icon ts" />
            </IconButton>
            {
              /* environment === 'dev' ? */ <IconButton
                className="attach-button"
                disabled={false} // todo: add condition
                disableToolTip={isMediumScreen}
                onClick={onAiIconClicked}
                toolTip={i18n.aiMenu.aiTooltipIcon}
                toolTipPosition="top"
                toolTipPositionOffset={5}
              >
                <AiIcon className="ai-icon ts" />
              </IconButton>
            }
            <FloatingMenu
              anchorEl={anchorIaMenu}
              i18n={i18n}
              isLoading={isAiLoading}
              isOpen={showAiMenu}
              saveSuggestion={setSuggestionAsValue}
              setAnchorEl={setAnchorIaMenu}
              setIsOpen={setShowAiMenu}
              sources={sourcesAi}
              suggestion={suggestionAi}
              summary={summaryAi}
            />
            <div
              ref={divRef}
              className="div-textarea"
              style={{ width: '100%' }}
            >
              <StyledTextArea
                ref={inputRef}
                className="send-message-textarea"
                disabled={isMessageSent || isLocked}
                hideText={disconnectedForAWhile}
                maxRows={4} // Máximo 4 líneas antes de mostrar scroll
                minRows={1}
                onBlur={({ target }) =>
                  setCaret({
                    start: target.selectionStart,
                    end: target.selectionEnd,
                  })
                }
                onChange={onChangeHandler}
                onKeyDown={introSubmit}
                placeholder={i18n?.placeholder}
                spellcheck={false}
                type="text"
                value={value}
              />
            </div>

            <IconButton
              className="send-button"
              disabled={isMessageSent || isLocked}
              onClick={sendMessageHandler}
            >
              <SendIcon className="send-icon ts" />
            </IconButton>
            <AttachMenuSelector
              hideToolTip={isMediumScreen}
              i18n={i18n}
              onAttachEvent={onAttachEvent}
              onSelectMenu={closeAttachMenu}
            />
            {/* <MinimalDrawer isOpen={showAiMenu}
            summary={summaryAi} suggestion={suggestionAi}
            setIsOpen={setShowAiMenu} i18n={i18n} isLoading={isAiLoading}
            saveSuggestion={setSuggestionAsValue}
            sources={sourcesAi}
          /> */}
            <TemplateSelector
              ref={templateSelectorRef}
              disabledTemplateSending={disabledTemplateSending}
              hideToolTip={isMediumScreen}
              i18n={i18n}
              isAuditor={isAuditor}
              list={templateList}
              onAddTemplate={handleAddTemplate}
              onDeleteTemplate={onDeleteTemplate}
              onTemplateSelected={(fragment) => setValue(fragment)}
              sendTemplate={sendTemplate}
              setTemplateToPreview={setTemplateToPreview}
              title={i18n.templateSelector.title}
            />

            {/* isAuditor && auditorTemplate && <button type="button" className="template-button-send" onClick={sendTemplate}>{`${i18n.chats.sendTemplate} ${auditorTemplate?.title}`}</button> */}
            <ReactTooltip type="info" />
          </>
        ) : (
          <button
            className="assign-self-button"
            onClick={assignConvToMyself}
            type="button"
          >
            {i18n.messageInput.assignConvToMyself}
          </button>
        )}
      </SendInputStyled>
      {(disconnectedForAWhile || isLocked) && (
        <>
          <Overlay>
            <WarningMessage
              message={
                isLocked
                  ? i18n?.messageInput?.assigning
                  : i18n?.messageInput?.disconnected
              }
            />
          </Overlay>

          <Blocker />
        </>
      )}
    </Wrapper>
  );
};

SendMessageInput.propTypes = {
  assignConvToMyself: PropTypes.func,
  conversations: PropTypes.array,
  disabledTemplateSending: PropTypes.bool,
  disconnected: PropTypes.bool,
  i18n: PropTypes.object,
  isAuditor: PropTypes.bool,
  isLocked: PropTypes.bool,
  onAddTemplate: PropTypes.func,
  onAttachEvent: PropTypes.func,
  onDeleteTemplate: PropTypes.func,
  sendTemplate: PropTypes.func,
  setGlobalState: PropTypes.func,
  setRetryTimers: PropTypes.func,
  setScrollAllowed: PropTypes.func,
  setTemplateToPreview: PropTypes.func,
  showOnlyButton: PropTypes.bool,
  templateList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      message: PropTypes.string,
    })
  ),
};

export default withI18n(SendMessageInput);
